import ServicePage from '../../components/service/ServicePage'

export default function Tampondruck() {
  return <ServicePage service="pad" lang="de" />
}
